import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  quickLinksPaper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    '@media (min-width: 1200px)': {
      borderRadius: 4,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 3px 0px rgba(0,0,0,0.12)',
    },
  },
  headerBox: {
    padding: '16px 24px 16px 24px',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.evPalette.charcoal[200]}`,
    '@media (max-width: 1200px)': {
      padding: '24px',
    },
  },
  headerText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24.52px',
    textAlign: 'left',
  },
  contentBox: {
    padding: '16px 24px 16px 24px',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    borderRadius: '0px 0px 4px 4px',
    justifyContent: 'space-between',
    '@media (max-width: 1200px)': {
      flexDirection: 'column',
      padding: '24px',
      gap: '24px',
    },
  },
  iconButton: {
    width: '44px',
    height: '44px',
    backgroundColor: theme.evPalette.charcoal[100],
    margin: 'auto 0px auto 0px',
    '@media (max-width: 1200px)': {
      margin: '0px',
    },
  },
  element: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    flexBasis: '100%',
  },
  contentText: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
    textDecoration: 'none',
    margin: 'auto 0px auto 0px',
    '@media (max-width: 1200px)': {
      marginLeft: '0px',
    },
  },
  links: {
    width: 'fit-content',
    margin: 'auto',
  },
}));
